export const countries = [
  { code: '+1', country: 'US', name: 'United States', flag: '🇺🇸', maxLength: 10 },
  { code: '+44', country: 'GB', name: 'United Kingdom', flag: '🇬🇧', maxLength: 10 },
  { code: '+61', country: 'AU', name: 'Australia', flag: '🇦🇺', maxLength: 9 },
  { code: '+91', country: 'IN', name: 'India', flag: '🇮🇳', maxLength: 10 },
  { code: '+81', country: 'JP', name: 'Japan', flag: '🇯🇵', maxLength: 10 },
  { code: '+86', country: 'CN', name: 'China', flag: '🇨🇳', maxLength: 11 },
  { code: '+49', country: 'DE', name: 'Germany', flag: '🇩🇪', maxLength: 11 },
  { code: '+33', country: 'FR', name: 'France', flag: '🇫🇷', maxLength: 9 },
  { code: '+39', country: 'IT', name: 'Italy', flag: '🇮🇹', maxLength: 10 },
  { code: '+34', country: 'ES', name: 'Spain', flag: '🇪🇸', maxLength: 9 },
  { code: '+7', country: 'RU', name: 'Russia', flag: '🇷🇺', maxLength: 10 },
  { code: '+55', country: 'BR', name: 'Brazil', flag: '🇧🇷', maxLength: 11 },
  { code: '+52', country: 'MX', name: 'Mexico', flag: '🇲🇽', maxLength: 10 },
  { code: '+27', country: 'ZA', name: 'South Africa', flag: '🇿🇦', maxLength: 9 },
  { code: '+82', country: 'KR', name: 'South Korea', flag: '🇰🇷', maxLength: 10 },
  { code: '+31', country: 'NL', name: 'Netherlands', flag: '🇳🇱', maxLength: 9 },
  { code: '+46', country: 'SE', name: 'Sweden', flag: '🇸🇪', maxLength: 9 },
  { code: '+47', country: 'NO', name: 'Norway', flag: '🇳🇴', maxLength: 8 },
  { code: '+45', country: 'DK', name: 'Denmark', flag: '🇩🇰', maxLength: 8 },
  { code: '+358', country: 'FI', name: 'Finland', flag: '🇫🇮', maxLength: 10 },
  { code: '+41', country: 'CH', name: 'Switzerland', flag: '🇨🇭', maxLength: 9 },
  { code: '+43', country: 'AT', name: 'Austria', flag: '🇦🇹', maxLength: 10 },
  { code: '+32', country: 'BE', name: 'Belgium', flag: '🇧🇪', maxLength: 9 },
  { code: '+351', country: 'PT', name: 'Portugal', flag: '🇵🇹', maxLength: 9 },
  { code: '+30', country: 'GR', name: 'Greece', flag: '🇬🇷', maxLength: 10 },
  { code: '+48', country: 'PL', name: 'Poland', flag: '🇵🇱', maxLength: 9 },
  { code: '+420', country: 'CZ', name: 'Czech Republic', flag: '🇨🇿', maxLength: 9 },
  { code: '+36', country: 'HU', name: 'Hungary', flag: '🇭🇺', maxLength: 9 },
  { code: '+40', country: 'RO', name: 'Romania', flag: '🇷🇴', maxLength: 10 },
  { code: '+353', country: 'IE', name: 'Ireland', flag: '🇮🇪', maxLength: 9 },
  { code: '+64', country: 'NZ', name: 'New Zealand', flag: '🇳🇿', maxLength: 9 },
  { code: '+65', country: 'SG', name: 'Singapore', flag: '🇸🇬', maxLength: 8 },
  { code: '+60', country: 'MY', name: 'Malaysia', flag: '🇲🇾', maxLength: 10 },
  { code: '+63', country: 'PH', name: 'Philippines', flag: '🇵🇭', maxLength: 10 },
  { code: '+66', country: 'TH', name: 'Thailand', flag: '🇹🇭', maxLength: 9 },
  { code: '+84', country: 'VN', name: 'Vietnam', flag: '🇻🇳', maxLength: 10 },
  { code: '+62', country: 'ID', name: 'Indonesia', flag: '🇮🇩', maxLength: 11 },
  { code: '+92', country: 'PK', name: 'Pakistan', flag: '🇵🇰', maxLength: 10 },
  { code: '+880', country: 'BD', name: 'Bangladesh', flag: '🇧🇩', maxLength: 10 },
  { code: '+94', country: 'LK', name: 'Sri Lanka', flag: '🇱🇰', maxLength: 9 },
  { code: '+977', country: 'NP', name: 'Nepal', flag: '🇳🇵', maxLength: 10 },
  { code: '+971', country: 'AE', name: 'UAE', flag: '🇦🇪', maxLength: 9 },
  { code: '+966', country: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', maxLength: 9 },
  { code: '+965', country: 'KW', name: 'Kuwait', flag: '🇰🇼', maxLength: 8 },
  { code: '+974', country: 'QA', name: 'Qatar', flag: '🇶🇦', maxLength: 8 },
  { code: '+973', country: 'BH', name: 'Bahrain', flag: '🇧🇭', maxLength: 8 },
  { code: '+968', country: 'OM', name: 'Oman', flag: '🇴🇲', maxLength: 8 },
  { code: '+962', country: 'JO', name: 'Jordan', flag: '🇯🇴', maxLength: 9 },
  { code: '+961', country: 'LB', name: 'Lebanon', flag: '🇱🇧', maxLength: 8 },
  { code: '+20', country: 'EG', name: 'Egypt', flag: '🇪🇬', maxLength: 10 },
  { code: '+212', country: 'MA', name: 'Morocco', flag: '🇲🇦', maxLength: 9 },
  { code: '+234', country: 'NG', name: 'Nigeria', flag: '🇳🇬', maxLength: 10 },
  { code: '+254', country: 'KE', name: 'Kenya', flag: '🇰🇪', maxLength: 10 },
  { code: '+233', country: 'GH', name: 'Ghana', flag: '🇬🇭', maxLength: 9 },
  { code: '+256', country: 'UG', name: 'Uganda', flag: '🇺🇬', maxLength: 9 },
  { code: '+255', country: 'TZ', name: 'Tanzania', flag: '🇹🇿', maxLength: 9 },
  { code: '+54', country: 'AR', name: 'Argentina', flag: '🇦🇷', maxLength: 10 },
  { code: '+56', country: 'CL', name: 'Chile', flag: '🇨🇱', maxLength: 9 },
  { code: '+57', country: 'CO', name: 'Colombia', flag: '🇨🇴', maxLength: 10 },
  { code: '+51', country: 'PE', name: 'Peru', flag: '🇵🇪', maxLength: 9 },
  { code: '+58', country: 'VE', name: 'Venezuela', flag: '🇻🇪', maxLength: 10 },
  { code: '+593', country: 'EC', name: 'Ecuador', flag: '🇪🇨', maxLength: 9 },
  { code: '+506', country: 'CR', name: 'Costa Rica', flag: '🇨🇷', maxLength: 8 },
  { code: '+507', country: 'PA', name: 'Panama', flag: '🇵🇦', maxLength: 8 },
  { code: '+503', country: 'SV', name: 'El Salvador', flag: '🇸🇻', maxLength: 8 },
  { code: '+502', country: 'GT', name: 'Guatemala', flag: '🇬🇹', maxLength: 8 },
  { code: '+504', country: 'HN', name: 'Honduras', flag: '🇭🇳', maxLength: 8 },
  { code: '+505', country: 'NI', name: 'Nicaragua', flag: '🇳🇮', maxLength: 8 },
];

export const getCountryByCode = (code) => {
  return countries.find(c => c.code === code) || countries[0];
};
